<template>
  <div id="app" :class="{ 'dark-mode': isDarkMode }">
    <nav class="tab-navigation">
      <div class="tabs">
        <button @click="activeTab = 'game'" :class="{ active: activeTab === 'game' }" class="tab-button">Game</button>
        <button @click="activeTab = 'stats'" :class="{ active: activeTab === 'stats' }" class="tab-button">Stats</button>
      </div>
      <button @click="toggleDarkMode" class="dark-mode-toggle" :title="isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
        <svg
          v-if="!isDarkMode"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line>
          <line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
      </button>
    </nav>

    <div class="tab-content">
      <GameTab v-if="activeTab === 'game'" />
      <StatsTab v-if="activeTab === 'stats'" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import GameTab from "./components/GameTab.vue";
import StatsTab from "./components/StatsTab.vue";

const activeTab = ref("game");
const isDarkMode = ref(false);

const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value;
  localStorage.setItem("darkMode", isDarkMode.value ? "true" : "false");
};

onMounted(() => {
  const savedMode = localStorage.getItem("darkMode");
  if (savedMode === "true") {
    isDarkMode.value = true;
  }
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  background-color: #ffffff;
  color: #1a1a1a;
  transition: background-color 0.3s ease, color 0.3s ease;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

/* Dark Mode Styles */
#app.dark-mode {
  background-color: #0f0f0f;
  color: #e0e0e0;
}

#app.dark-mode body {
  background-color: #0f0f0f;
  color: #e0e0e0;
}

.tab-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px 20px;
  border-bottom: 1px solid #e0e0e0;
  transition: border-color 0.3s ease;
}

.dark-mode .tab-navigation {
  border-bottom-color: #2a2a2a;
}

.tabs {
  display: flex;
  gap: 10px;
  flex: 1;
  justify-content: center;
}

.tab-button {
  background: none;
  border: none;
  padding: 12px 30px;
  font-size: 1rem;
  font-weight: 500;
  color: #999;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.tab-button:hover {
  color: #1a1a1a;
  background-color: #f8f8f8;
}

.dark-mode .tab-button:hover {
  color: #e0e0e0;
  background-color: #1a1a1a;
}

.tab-button.active {
  color: #1a1a1a;
  background-color: #f0f0f0;
}

.dark-mode .tab-button.active {
  color: #e0e0e0;
  background-color: #1f1f1f;
}

.dark-mode-toggle {
  background: none;
  border: 2px solid #e0e0e0;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  color: #1a1a1a;
}

.dark-mode-toggle:hover {
  background-color: #f8f8f8;
  transform: rotate(15deg) scale(1.05);
}

.dark-mode .dark-mode-toggle {
  border-color: #3a3a3a;
  color: #ffffff;
}

.dark-mode .dark-mode-toggle:hover {
  background-color: #1a1a1a;
  border-color: #4a4a4a;
}

.dark-mode-toggle svg {
  transition: color 0.3s ease;
}

.tab-content {
  padding: 20px;
}
</style>
